import React, { memo } from 'react'

interface Props{
  footer: string | undefined
}

const Footer: React.FC<Props> = ({ footer }) => {
  if (!footer) return null
  return <div dangerouslySetInnerHTML={{ __html: footer }} />
}

export default memo(Footer)
